/**
 * @module app.shared
 */

import { IApiQueryFilter } from './api-filters';
import { QuerySessionValue } from './api-types';
import { encodeFieldName, encodeStringLiteral } from './api-utilities';

export class ApiQuerySessionFilter implements IApiQueryFilter {

    constructor(public field: string, public value: QuerySessionValue, public modelCode?: string) { }

    public toString(): string {
        const encodedField = encodeFieldName(this.field);
        let encodedValue: string | null = null;

        if(this.value === '$context.id') {
            const code = `\$${this.modelCode || ''}`;
            encodedValue = `session(${encodeStringLiteral(code)})`;
        }
        else {
            encodedValue = `session(${encodeStringLiteral(this.value)})`;
        }

        return `${encodedField}+eq+${encodedValue}`;
    }

}
